import React, { useContext, useState, useEffect } from 'react';
import { Container, Typography } from '@mui/material';
import Layout from '../../component/Layout';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import TextField from '@mui/material/TextField';
import api from '../../connection/Axios';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import icoArrowRight from '../../assets/icoArrowRight.png'
import moment from 'moment-timezone';


const BuscarVistorias = () => {
  const [userData, setUserData] = useContext(UserProfile)
  const [systemData, setSystemData] = useContext(SystemProfile)
  const [idVistoria, setIdVistoria] = useState(0)
  const [vistorias, setVistorias] = useState([])
  const [getVistoria, setGetVistoria] = useState(false)
  const [vistoria, setVistoria] = useState([])

  const headers = {
    headers: {
      "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${userData.token}`
    }};

    async function GetServices() {
      api.post('vistoria/getServices', headers).then(response => {
        setVistorias(response.data)
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }
    
    useEffect(()=>{
      GetServices()
    }, [])



    const Box = (props) => {

      const StatusColor = () => {
        switch (props.data.status) {
            case 'pendente' : return <div style={{borderColor: '#ff8536', color: '#ff8536'}} className='vistoriaStatus'><b>Status:&nbsp;&nbsp;{props.data.status}</b></div>
            case 'atencao' : return <div style={{borderColor: '#aa0000', color: '#aa0000'}} className='vistoriaStatus'><b>Status:&nbsp;&nbsp;{props.data.status}</b></div>
            case 'resolvido' : return <div style={{borderColor: '#494949', color: '#494949'}} className='vistoriaStatus'><b>Status:&nbsp;&nbsp;{props.data.status}</b></div>
            default : return '#000000' 
        }
    }

      return(
        <>
        
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', flex: 1}}>
            <div style={styles.vistoria}>
            <div style={{width: 200}}>
                <div style={{color: '#000000', fontSize: 13, fontWeight: 600}}>{props.data.empreend}</div>
                <div style={{color: '#ed6e2d', fontSize: 13, fontWeight: 600, marginRight: 15}}>{props.data.id}</div>
              </div>  
              
                <div style={{width: 280}}>
                  <div style={{fontSize: 13}}>Vistoriador: <b>{props.data.vistoriador}</b></div>
                  <div style={{fontSize: 13}}>Agenda: <span style={{color: '#ed6e2d',}}><b>{moment(props.data.dataHora).format('DD/MM/YYYY - HH:mm')}</b></span></div>
                </div>
                
                  <StatusColor />
                  <Button component={Link} to="/vistoria-detalhe" state={{data: props.data}} style={{backgroundColor: '#ffffff', paddingLeft:20, border: 'none'}}>
                    <img src={icoArrowRight} width='10' />
                  </Button>
                

            </div>
          </div>
        </>
      )
    }

  return (
    <>
        <Layout breadcrumb='Dashboard / Inspeções / Buscar Inspeções' title='Buscar Inspeções'>

        <TextField onChange={(event) => setIdVistoria(event.target.value)} label="Digite o ID da inspeção" variant="outlined"  style={{width: '100%'}} />
        <br />

        {vistorias?.reverse().filter(vistoria => vistoria.id == idVistoria).map((vist, index)=>(
          <Box data={vist} key={index} />
        ))}

        </Layout>
    </>
  );
};

export default BuscarVistorias


const styles = {
  vistoria: {
      backgroundColor: '#FFFFFF',
      padding: 20,
      borderRadius: 12,
      marginBottom: 10,
      display: 'flex',
      color: '#000000',
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      width: '100%'
  },
  vistoria2: {
      backgroundColor: '#002638',
      padding: 20,
      borderRadius: 12,
      marginBlock: 20,
      display: 'flex',
      color: '#ffffff',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      width: '100%',
      fontSize: 15
  },
  setaOn: {
    
  },
  setaOff: {
    transform: [{rotateX: 180}],

  }
}